import { roleSchema } from '../../../schemas/role.schema';
import { z } from 'zod/v4';

export const applicationRoleSchema = z.object({
  id: z.string().min(1),
  name: roleSchema,
  allowed: z.boolean(),
});

export type ApplicationRole = z.infer<typeof applicationRoleSchema>;
